import Text from "@ui-kit/typography/Text/Text.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { BannerSubtitleProps } from "./BannerSubtitle.props";
import { useBannerSubtitle } from "./useBannerSubtitle";

/**
 * Displays a subtitle on the seating banner, based on the available data.
 * This subtitle can be:
 *
 * The start date and location information,
 * The start and end dates with the venue name,
 * Or just the venue name by itself.
 */
const BannerSubtitle = ({
  seatingObject,
  venueObject,
}: BannerSubtitleProps) => {
  const { getDateLabel, getLocationLabel } = useBannerSubtitle();

  const dateLabel = getDateLabel(seatingObject);
  const locationLabel = getLocationLabel(seatingObject?.location);

  return (
    <Flex alignItems="flex-end" color="gray.600">
      <Text
        fontSize={{ base: "xs", md: "sm" }}
        overflow="hidden"
        whiteSpace="normal"
        noOfLines={1}
      >
        {dateLabel}
      </Text>
      {dateLabel.length > 0 && <Box minW="element.sm" />}
      <Text
        noOfLines={1}
        overflow="hidden"
        whiteSpace="normal"
        fontSize={{ base: "xs", md: "sm" }}
      >
        {seatingObject?.location ? locationLabel : venueObject.name}
      </Text>
    </Flex>
  );
};

export default BannerSubtitle;
